import { createSlice } from "@reduxjs/toolkit";

const errorDialogSlice = createSlice({
  name: "errorDialog",
  initialState: { open: false, message: "" },
  reducers: {
    showErrorDialog: (state, action) => {
      state.open = true;
      state.message = action.payload;
    },
    closeErrorDialog: (state) => {
      state.open = false;
      state.message = "";
    },
  },
});

export const { showErrorDialog, closeErrorDialog } = errorDialogSlice.actions;
export default errorDialogSlice.reducer;
